// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: 'AIzaSyAIkeWWuLQnMSv16lzl3_TEWaYqVzGUGXw',
        authDomain: 'nextcare-poc.firebaseapp.com',
        databaseURL: 'https://nextcare-poc.firebaseio.com',
        projectId: 'nextcare-poc',
        storageBucket: '',
        messagingSenderId: '930188563903',
        appId: '1:930188563903:web:4f5081483cdf88ad'
    }
};
